import type { ServiceCreate } from "@/types/services/api-types/service-types";
import type { addServiceSchemaSchema } from "@/zod-schemas/services/add-service-schema";
import type { z } from "zod";

type ServiceFormValidated = z.infer<typeof addServiceSchemaSchema>;

export const toServiceRequest = (
  value: ServiceFormValidated,
): ServiceCreate => ({
  name: value.name,
  description: value.description,
  category_id: value.category.value,
  //TODO: This will change once we have the ability to add multiple staff levels to a service
  staff_tier_config: [
    {
      staff_level: value.staff_level,
      duration: value.duration,
      price: value.price,
    },
  ],
});
